import{customAlphabet as r}from"nanoid";var n=o=>r("0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz",o||7)();export{n as a};
